/**
 * **The routes that render the correspondence-setup flow full screen** — no app
 * sidebar, no workspace chrome (VALE-1470).
 *
 * `providers-wrapper.tsx` reads this to decide whether to wrap a page in the
 * authenticated app shell. It is a **set** rather than a comparison because the
 * `/onboarding` prefix is genuinely mixed:
 *
 * | Route | Chrome |
 * |---|---|
 * | `/onboarding` | none — the first-sign-in flow |
 * | `/onboarding/review` | none — the same flow, opened deliberately (VALE-1412) |
 * | `/onboarding/get-started` | **the app sidebar**, because the hub is a dashboard page |
 *
 * So a `startsWith('/onboarding')` is wrong in a way that is easy to reach for
 * and would silently strip the hub's sidebar, and an equality check against one
 * route is wrong in the way that produced this ticket: VALE-1412 added the
 * review route, the gate still named only `/onboarding`, and the review route
 * rendered inside the workspace shell while its first-sign-in twin did not.
 *
 * **Adding a route to the flow means adding it here.**
 * `__tests__/full-screen-routes-registry.test.ts` derives every route under
 * `app/onboarding/` from disk and reconciles it against this list plus
 * {@link CHROME_BEARING_ONBOARDING_ROUTES}, in both directions, so a new
 * sub-route fails the suite until someone states which kind it is.
 */
export const FULL_SCREEN_SETUP_ROUTES: readonly string[] = [
  '/onboarding',
  '/onboarding/review'
];

/**
 * The other half of the set: routes under `app/onboarding/` that deliberately
 * **keep** the app sidebar.
 *
 * Declared rather than inferred, so the registry test can tell "this route was
 * considered and belongs in the shell" apart from "nobody has classified this
 * route yet". Without it the reconciliation could only ever check one
 * direction, and a new sub-route would read as correctly excluded.
 */
export const CHROME_BEARING_ONBOARDING_ROUTES: readonly string[] = [
  '/onboarding/get-started'
];
